import { apiSlice } from '../../store/api/apiSlice';
import { encryptData } from '../../shared/services/cryptoService';
export const tlmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ================= REQUEST OTP =================
    requestOtp: builder.mutation<any, { UserId: string; newPassword: string }>({
      query: ({ UserId, newPassword }) => {
        const data = {
          userDetails: {
            otp_purpose_id: 6,
            triggered_by_username: UserId,
            triggered_for_username: UserId,
            sms_strings: newPassword,
          },
          otpTemplate: {
            TemplateId: '1707167782158667552',
            MobileNo: '',
            TemplateMsg:
              'OTP to reset password for EMIS Username {#var#} is {#var#}. Do not share with anyone. - TNSED',
            var: {
              var1: '',
              var2: '',
            },
          },
        };
        return {
          url: 'OtpPasswordReset',
          method: 'POST',
          body: encryptData(data),
          service: 'djangoTnEmis',
        };
      },
    }),

    // requestOtp: builder.mutation<any, { UserId: string; newPassword: string }>({
    //   query: ({ UserId, newPassword }) => {
    //     const data = {
    //       userDetails: {
    //         otp_purpose_id: 6,
    //         triggered_by_username: UserId,
    //         triggered_for_username: UserId,
    //         sms_strings: newPassword, // ← This must be in userDetails
    //       },
    //       otpTemplate: {
    //         TemplateId: '1707167782158667552',
    //         MobileNo: '',
    //         TemplateMsg:
    //           'OTP to reset password for EMIS Username {#var#} is {#var#}. Do not share with anyone. - TNSED',
    //         var: { var1: '', var2: '' },
    //       },
    //     };

    //     // console.log('Sending OTP request with data:', data); // Debug log

    //     const encrypted = encryptData(data);
    //     return {
    //       url: 'OtpPasswordReset',
    //       method: 'POST',
    //       body: encrypted,
    //       service: 'djangoTnEmis',
    //     };
    //   },
    // }),

    // ================= SUBMIT OTP =================
    submitOtp: builder.mutation<
      any,
      {
        username: string;
        otp: string;
      }
    >({
      query: ({ username, otp }) => {
        const data = {
          triggered_by_username: username,
          otp_purpose_id: 6,
          otp,
        };
        return {
          url: 'OtpPasswordResetSub',
          method: 'POST',
          body: encryptData(data),
          service: 'djangoTnEmis',
        };
      },
    }),

    // ================= UPDATE PASSWORD =================
    updatePassword: builder.mutation<
      any,
      {
        username: string;
        newPass: string;
      }
    >({
      query: ({ username, newPass }) => {
        const data = {
          triggered_by_username: username,
          newPass,
        };

        return {
          url: 'UpdateUserPassword',
          method: 'POST',
          body: encryptData(data),
          service: 'djangoTnEmis',
        };
      },
    }),

    // ================= LOGIN =================
    login: builder.mutation<
      any,
      {
        username: string;
        password: string;
      }
    >({
      query: ({ username, password }) => {
        return {
          url: 'testnewlogin',
          method: 'POST',
          // headers: {
          //   'Content-Type': 'application/json',
          //   Accept: 'application/json',
          //   Authorization: 'EMIS@2019_api',
          // },
          body: {
            records: {
              emis_username: username,
              emis_password: password,
            },
          },
          service: 'emis_login',
        };
      },
    }),

    getTnEmisMenuOptions: builder.query<any, void>({
      query: () => ({
        url: 'getTnEmisMenuOptions',
        method: 'GET',
        service: 'djangoSupport',
      }),
    }),

    getCurrentAy: builder.query<any, void>({
      query: () => ({
        url: 'currentAy',
        method: 'GET',
        service: 'djangoEmis',
      }),
    }),
  }),
});

export const {
  useRequestOtpMutation,
  useSubmitOtpMutation,
  useUpdatePasswordMutation,
  useLoginMutation,
  useLazyGetTnEmisMenuOptionsQuery,
  useLazyGetCurrentAyQuery,
} = tlmApi;
